module.exports = __webpack_public_path__ + "media/images/loghi/mylba_title-66292410b8954f01adff99e401eac534.png";